// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".diff-check[data-v-6e63f3d9]{align-items:center;background-color:#fff;border:1px solid #e6e7eb;border-radius:11px;display:flex;height:48px;justify-content:space-between;padding:12px}.diff-check__label[data-v-6e63f3d9]{color:#494c55;font-size:17px;font-weight:600;line-height:22px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
